export function getAvatarColorClass(seed?: string) {
  const palette = [
    'bg-rose-500 text-white',
    'bg-fuchsia-500 text-white',
    'bg-amber-400 text-black',
    'bg-sky-500 text-white',
    'bg-green-500 text-white',
    'bg-indigo-500 text-white',
    'bg-pink-500 text-white',
    'bg-emerald-500 text-white',
  ];
  const key = (seed || '').trim() || String(Math.random());
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h << 5) - h + key.charCodeAt(i);
    h |= 0;
  }
  const idx = Math.abs(h) % palette.length;
  return palette[idx];
}

// Outcome color utility for consistent styling across the app
export function getOutcomeColorClass(outcome: string): string {
  switch (outcome) {
    case 'Initiated':
      return 'text-blue-700 dark:text-blue-400';
    case 'Ongoing':
      return 'text-yellow-700 dark:text-yellow-400';
    case 'Answered':
      return 'text-green-700 dark:text-green-400';
    case 'Voicemail':
      return 'text-purple-700 dark:text-purple-400';
    case 'Busy':
      return 'text-purple-700 dark:text-purple-400';
    case 'Unanswered':
      return 'text-red-700 dark:text-red-400';
    case 'Error':
      return 'text-orange-700 dark:text-orange-400';
    default:
      return 'text-gray-700 dark:text-gray-400';
  }
}

// Avatar generation utility - centralized to avoid duplication
export function generateAvatarHash(input: string): string {
  const base = [
    '#FF6B6B',
    '#4ECDC4',
    '#45B7D1',
    '#96CEB4',
    '#FFEAA7',
    '#DDA0DD',
    '#98D8C8',
    '#F7DC6F',
    '#BB8FCE',
    '#85C1E9',
  ];

  if (!input) return base[0];

  const hash = input.split('').reduce((a, c) => a + c.charCodeAt(0), 0) % base.length;

  return base[hash];
}

// Outcome hex colors for charts
export const OUTCOME_COLORS = {
  Initiated: '#1d4ed8',
  Answered: '#15803d',
  Ongoing: '#a16207',
  Busy: '#9333ea',
  Voicemail: '#7c3aed',
  Unanswered: '#b91c1c',
  Error: '#c2410c',
} as const;

export default getAvatarColorClass;
